import store from '../Store/index';

const student_routes = [
  {
    path: '/chat',
    component: () => import('../Pages/Chat.vue'),
    name: 'Chat',
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },

  {
    path: '/board-draw',
    component: () => import('../Pages/BoardDraw.vue'),
    name: 'BoardDraw',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mobile-dashbord',
    component: () => import('../Pages/MobileDashbord.vue'),
    name: 'MobileDashbord',
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/controllers',
    component: () => import('../Pages/Security/Blocks/ControllersAcc.vue'),
    name: 'ControllersAcc',
    meta: {
      requiresAuth: true,
      part: ''
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/smart-campus',
    component: () => import('../Pages/Security/Blocks/Controllers.vue'),
    name: 'Controllers',
    meta: {
      requiresAuth: true,
      part: ''
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  }
];
const blank_pdf_routes = [];

const study_center = [];
const worker_routes = [];
const setting_routes = [
  {
    path: '/settings',
    component: () => import('../Pages/Settings/Settings.vue'),
    name: 'Settings',
    meta: {
      requiresAuth: true,
      part: 'settings'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/settings-departments',
    component: () => import('../Pages/Settings/DepartmentList.vue'),
    name: 'DepartmentsList',
    meta: {
      requiresAuth: true,
      part: 'settings'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/settings/roles',
    component: () => import('../Pages/Settings/RoleList.vue'),
    name: 'RolesList',
    meta: {
      requiresAuth: true,
      part: 'settings'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/settings-management-list',
    component: () => import('../Pages/Settings/ManagementList.vue'),
    name: 'ManagementList',
    meta: {
      requiresAuth: true,
      part: 'settings'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  }
];
const auth_routes = [
  {
    path: '/sign-in',
    component: () => import('../Pages/SignIn.vue'),
    name: 'SignIn',
    meta: {
      layout: 'auth-layout'
    }
  },

  {
    path: '/forgot-password',
    component: () => import('../Pages/ForgotPassword.vue'),
    name: 'ForgotPassword',
    meta: {
      layout: 'auth-layout'
    }
  },

  {
    path: '/first-change-password',
    component: () => import('../Pages/FirstChangePassword.vue'),
    name: 'FirstChangePassword',
    meta: {
      layout: 'auth-layout',
      requiresAuth: true
    }
  },
  {
    path: '/reset-password/:token/:email',
    component: () => import('../Pages/ResetPassword.vue'),
    name: 'ResetPassword',
    meta: {
      layout: 'auth-layout'
    }
  },
  {
    path: '/login',
    component: () => import('../Pages/SignIn.vue'),
    name: 'SignIn',
    meta: {
      layout: 'auth-layout'
    }
  },
  {
    path: '/sign-in-confirm',
    component: () => import('../Pages/ConfirmAuth.vue'),
    name: 'Confirm',
    meta: {
      layout: 'auth-layout'
    }
  }
];
const maintenance_routes = [];
const security_routes = [];
const blanks_routes = [];
let routes = [
  {
    path: '/',
    component: () => import('../Pages/HomePage.vue'),
    name: 'HomePage',
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'MobileDashbord' });
      } else {
        next();
      }
    }
  }
];
routes = routes.concat(auth_routes);
routes = routes.concat(student_routes);
routes = routes.concat(study_center);
routes = routes.concat(worker_routes);
routes = routes.concat(maintenance_routes);
routes = routes.concat(setting_routes);
routes = routes.concat(blank_pdf_routes);
routes = routes.concat(blanks_routes);
routes = routes.concat(security_routes);
const all_routes = routes;
// meta:
// requiresAuth: -  only for auth users
// part: -  for header menu
// item: -  for sidebar menu
export default all_routes;
